module.exports = __webpack_public_path__ + "static/media/googlemaps.df7bf8d3.png";